import { FluffyInternalBenefits } from '../configs/benefitInfoConfig';

import { Currency } from '../constants/currency';

import { ProductBenefitCode, ProductBenefitSchema } from '../types/benefits';

const NUMBERS_REGEXP = new RegExp('\\d');
const MILLION_ZERO_REGEXP = '000000';
const MILLION_LETTER = 'M';
const DOGS_ONLY_LABEL_MARKER_REGEXP = '(Dogs Only)';
const EMPTY_STRING = '';
const DOG_ONLY_BENEFITS: ProductBenefitCode[] = ['THIRD_PARTY_LIABILITY'];

const PERKS_VIEW_ORDER: ProductBenefitCode[] = [
  'VET_FEES',
  'THIRD_PARTY_LIABILITY',
  'DENTAL_TREATMENT',
  'CT_AND_MRI_SCAN',
  'EXCESS',
  'ACCIDENT_DEATH',
  'ILLNESS_DEATH',
  'BOARDING',
  'THEFT',
  'HOLIDAY_CANCELLATION',
  'ADVERTISING',
  'PET_PASSPORT',
  'OVERSEAS_TRAVEL',
  'QUARANTINE',
  'EMERGENCY_ABROAD',
  'ACCIDENTAL_DAMAGE',
  'VET_HELPLINE',
];

export function filterProductBenefitsToDisplay(
  benefits: ProductBenefitSchema[],
  isDogPetType?: boolean,
): ProductBenefitSchema[] {
  const selectedBenefitCodes: ProductBenefitCode[] = [
    'VET_FEES',
    'VET_HELPLINE',
    'THEFT',
    'ILLNESS_DEATH',
    'ADVERTISING',
    'BOARDING',
    ...(isDogPetType ? DOG_ONLY_BENEFITS : []),
    'HOLIDAY_CANCELLATION',
    'EMERGENCY_ABROAD',
  ];

  return benefits.filter((benefit) => selectedBenefitCodes.includes(benefit.code));
}

export function formatProductBenefitNameLabel(name: string) {
  return name.replace(DOGS_ONLY_LABEL_MARKER_REGEXP, EMPTY_STRING).trim();
}

export function formatProductBenefitAmountLabel(amount: string) {
  if (NUMBERS_REGEXP.test(amount)) {
    const shortenedAmount = amount.replace(MILLION_ZERO_REGEXP, MILLION_LETTER);

    return `Up to ${Currency.GBP}${shortenedAmount}`;
  }

  return 'Free';
}

export function getProductBenefitData(
  benefits: ProductBenefitSchema[],
  benefitCode: ProductBenefitCode,
): ProductBenefitSchema | undefined {
  return benefits.find((benefit) => benefit.code === benefitCode);
}

export function getAllAvailableInsuranceBenefits(benefits: ProductBenefitSchema[], isDogPetType?: boolean) {
  return [...FluffyInternalBenefits, ...filterProductBenefitsToDisplay(benefits, isDogPetType)];
}

export function getAvailableInsuranceBenefitsSetInViewOrder(benefits: ProductBenefitSchema[], isDogPetType?: boolean) {
  const availablePerks = getAllAvailableInsuranceBenefits(benefits, isDogPetType);

  return PERKS_VIEW_ORDER.map<ProductBenefitSchema | undefined>((perkCode) =>
    availablePerks.find(({ code }) => code === perkCode),
  ).filter(Boolean) as ProductBenefitSchema[];
}
